module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Shopping/Pound-9f1bd875501384d2fc1f38a07adaa5b5.svg";